import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '@/features/auth/AuthProvider'

export const CONSENT_TXN_KEY = 'mcp_consent_txn'

// After the login round-trip (which returns to the app root), if we stashed a
// pending consent txn before login and the author is now authed, resume the
// consent flow. Consumed once.
export const useConsentReturn = () => {
  const { isAuthorized } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (!isAuthorized) return
    if (pathname === '/oauth/consent') return
    const txn = sessionStorage.getItem(CONSENT_TXN_KEY)
    if (!txn) return
    sessionStorage.removeItem(CONSENT_TXN_KEY)
    navigate(`/oauth/consent?txn=${encodeURIComponent(txn)}`, { replace: true })
  }, [isAuthorized, pathname, navigate])
}
